/**
 * @description
 * Returns current app's mode.
 *
 * @returns {string}
 */
export const getMode = () => process?.env?.NODE_ENV || 'production'
